const state = {
  image3D: "",
  projectId: "",
  material: "",
};

const stateProxy = new Proxy(state, {
  set(target, key, value) {
    target[key] = value;
    const nodes = document.querySelectorAll(`input[name="properties[${key}]"]`);
    for (const node of nodes) {
      node.value = value;
    }
  },
});

function initPacdoraProductForm() {
  const forms = document.querySelectorAll("pacdora-state-form");

  const keys = Object.keys(state);
  for (let k = 0; k < forms.length; k++) {
    for (let i = 0; i < keys.length; i++) {
      const propEle = document.createElement("input");
      propEle.type = "hidden";
      propEle.name = `properties[${keys[i]}]`;
      propEle.value = state[keys[i]];
      forms[k].appendChild(propEle);
    }
  }
}

function init3DView() {
  const imgs = document.querySelectorAll(".product img");
  const matchedElement = Array.from(imgs).find((el) =>
    el.src.match(/.*3d_preview.jpg.*/),
  );
  if (matchedElement) {
    const div = document.createElement("div");
    Object.assign(div.style, { width: "100%", height: "100%" });
    matchedElement.parentNode.insertBefore(div, matchedElement);
    matchedElement.parentNode?.removeChild(matchedElement);
    div.dataset.pacdoraUi = "3d";
  }
}
function initPacdora(appId, version, options) {
  initPacdoraProductForm();
  init3DView();

  var script = document.createElement("script");
  script.type = "text/javascript";
  script.src = `https://cdn.pacdora.com/Pacdora-v${version}.js`;
  script.defer = true;
  script.onload = async () => {
    try {
      const loader = document.getElementById("3d_loading_pac");
      const loader_txt = document.getElementById("pac_loading_design_btn");
      const originalText = loader_txt.textContent;
      loader.style.display = "block";
      loader_txt.textContent = "Loading..";
      loader_txt.classList.add("disabled");
      await Pacdora.init({
        appId: appId,
        // userId: "9e6d5b9f59614",
        isDelay: true,
        doneBtn: "Save",
        theme: "#052541",
        localeResource: {
          Outside: "Outside View",
          Inside: "Inside View",
        },
      });

      //
      const config = {
        width: undefined,
        height: undefined,
        length: undefined,
      };

      if (options.dimension) {
        // dimension = 100mm*100mm*100mm
        const items = options.dimension.split("*");
        // 100mm -> 100
        config.width = parseFloat(items[0].replace("mm", ""));
        config.length = parseFloat(items[1].replace("mm", ""));
        config.height = parseFloat(items[2].replace("mm", ""));
      }

      const id = await Pacdora.createScene({
        modelId: options.modelId,
        templateId: options.templateId,
        width: config.width,
        height: config.height,
        length: config.length,
        doneBtn: "Save",
        showSize: false,
        showMaterial: false,
        isCreatePreview: false,
        packagingColors: ["#ff0000", "#00ff00", "#0000ff", "#893829"],
        // internale dimension
        advancedSetting: {
          sizeType: 1,
        },
      });
      loader.style.display = "none";
      loader_txt.textContent = originalText;
      loader_txt.classList.remove("disabled");
      Pacdora.$on("design:save", (data) => {
        console.log("Saving");
        loader_txt.textContent = "Edit Design";
      });

      // init Form
      stateProxy.projectId = id;
      const info = await Pacdora.getBoxInfo();
      stateProxy.image3D = info.screenshot;
      Pacdora.$on("design:save", async (data) => {
        const info = await Pacdora.getBoxInfo();
        stateProxy.image3D = info.screenshot;
      });

      definePacdoraBoxMaterial(
        ".product",
        "select[name='options[Material]']",
        options,
      );
    } catch (err) {
      console.warn("Pacdora error:", err);
    }
  };

  document.body.appendChild(script);
}

function definePacdoraBoxMaterial(queryFn, selector, setting) {
  const dom = document.querySelector(queryFn);
  if (dom) {
    const el = dom.querySelector(selector);
    onMaterialChange(el?.parentNode, setting);
    dom.addEventListener("change", async (e) => {
      try {
        // disableAddCart(true);
        const path = e.composedPath() || e.path;
        const dom = path.find(
          (el) =>
            el &&
            el.querySelector &&
            el == el.querySelector(selector)?.parentNode,
        );
        if (dom) {
          e.stopPropagation();
          await onMaterialChange(dom, setting);
        }
      } catch (err) {
        console.error(err);
      }
    });
  }

  // if there is no material option setmateria to the default one
  if (!setting.materialConfig) {
    return;
  }
  if (setting.materialConfig.toLowerCase().includes("karft")) {
    Pacdora.setMaterial({
      name: "Kraft Brown",
      image: "//cdn.pacdora.com/science/image/material_kraft.png",
      side: "https://cdn.pacdora.com/user-materials-mockup_mockup/e31c0a4c-8549-477a-99c9-363d64e3000d.png",
      async: true,
    });
  } else {
    Pacdora.setMaterial({
      name: "White",
      image:
        "//cdn.pacdora.com/science/image/94e8078a-9931-42cd-97ed-57883bd88085.png",
      async: true,
    });
  }
}

function getVariantValue(dom, setting) {
  return dom.querySelector("select")?.value;
}

function onChangeMaterial() {
  // empty function, don't do anything to this function
}

function onChangeTapeMaterial() {
  // empty function, don't do anyting here
}

async function onMaterialChange(dom, setting, sync = true) {
  //console.log('start');
  if (!dom) {
    return;
  }
  const materialMap = {
    "Gloss White": {
      name: "Gloss White",
      image:
        "//cdn.pacdora.com/science/image/94e8078a-9931-42cd-97ed-57883bd88085.png",
      async: true,
    },
    "Matte White": {
      name: "Matte White",
      image:
        "//cdn.pacdora.com/science/image/94e8078a-9931-42cd-97ed-57883bd88085.png",
      async: true,
    },
    "Kraft Brown": {
      name: "Kraft Brown",
      image: "//cdn.pacdora.com/science/image/material_kraft.png",
      side: "https://cdn.pacdora.com/user-materials-mockup_mockup/e31c0a4c-8549-477a-99c9-363d64e3000d.png",
      async: true,
    },
  };

  const value = getVariantValue(dom, setting);
  const loader = document.getElementById("3d_loading_pac");
  const loader_txt = document.getElementById("pac_loading_design_btn");
  const originalText = loader_txt.textContent;
  loader.style.display = "block";
  loader_txt.textContent = "Loading..";
  loader_txt.classList.add("disabled");
  if (materialMap[value]) {
    await Pacdora.setMaterial(materialMap[value]);
  }
  loader.style.display = "none";
  loader_txt.textContent = originalText;
  loader_txt.classList.remove("disabled");
}
